import { csx, Flex, IconCurrencyCircleDollar, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { CURRENCY_FRACTION_DIGITS } from 'shared'
import { ItemPriceRange } from 'typings'
import { Tag } from '../../../Tag'
import { useNumbers } from '../../../utils/useNumbers'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { messages } from './messages'

type Props = {
  config: ItemPriceRange | undefined
  onEdit: () => void
  onRemove: () => void
}

export function getItemPriceRangeCriteria(config: ItemPriceRange) {
  const { min, max } = config

  if (min && !max) return 'floor'
  if (!min && max) return 'ceil'
  else return 'range'
}

export function ItemPriceRangeView(props: Props) {
  const { $t } = useIntl()
  const { formatCurrency } = useNumbers()

  const { config, onEdit, onRemove } = props

  if (!config) return null

  const { min, max } = config

  const criteria = getItemPriceRangeCriteria(config)

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconCurrencyCircleDollar />
      </RuleIcon>

      <RuleDescription>
        {$t(messages.view.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
          criteria,
        })}
      </RuleDescription>

      <RuleContent>
        {criteria === 'floor' && <Tag>{formatCurrency(min ?? 0)}</Tag>}

        {criteria === 'ceil' && <Tag>{formatCurrency(max ?? 0)}</Tag>}

        {criteria === 'range' && (
          <Flex align="center" className={csx({ columnGap: '$space-2' })}>
            {$t(messages.view.valueRange, {
              minValue: <Tag>{formatCurrency(min ?? 0)}</Tag>,
              maxValue: <Tag>{formatCurrency(max ?? 0)}</Tag>,
            })}
          </Flex>
        )}
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
